export interface IEligibilityTransaction {
  eligibilityRequestId: string;
  eligibilityId: string;
  purpose: string[];
  isBenefits: boolean;
  isValidation: boolean;
  isDiscovery: boolean;
  payerId: string;
  payerNameEnglish: string;
  payerNameArabic: string;
  serviceDate?: string;
  beneficiaryId: string;
  beneficiaryFullName: string;
  statusId: string;
  statusNameArabic?: string;
  statusNameEnglish?: string;
  processStatusId: string;
  processStatusNameArabic?: string;
  processStatusNameEnglish?: string;
  providerId?: string;
  providerNameArabic?: string;
  providerNameEnglish?: string;
}

export const eligibilityConfig = {
  entityName: 'ELIGIBILITY.ELIGIBILITY_REQUEST',
  enligibilityId: 'ELIGIBILITY.ELIGIBILITY_TRANSACTION.ELIGIBILITY_ID',
  serviceDate: 'ELIGIBILITY.SERVICE_DATE',
  serviceStartDate: "PREAUTH.PREAUTH_PROCESS.SERVICE_START_DATE",
  serviceEndDate: "PREAUTH.PREAUTH_PROCESS.SERVICE_END_DATE",
  siteEligibility: 'ELIGIBILITY.SITE_ELIGIBLITY',
  status: 'PREAUTH.PREAUTH_TRANSACTION.STATUS',
  purpose: 'ELIGIBILITY.PURPOSE',
  insuranceCompany: 'INSURANCE_COMPANY.TITLE',
  provider: 'PROVIDER.TITLE',
  beneficiaryName: 'PREAUTH.PREAUTH_TRANSACTION.BENEFICIARY_NAME',
  benefit: 'CONFIGURATION.BENEFIT.TITLE',
  discovery: 'ELIGIBILITY.DISCOVERY',
  validation: 'ELIGIBILITY.VALIDATION'
};